<template>
  <div class="page_settlementTask">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px">
            <el-form-item label="系统表头" size="small">
              <el-input v-model="listQuery.sysName" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <div class="top-right">
        <el-button v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>AI小杰</el-breadcrumb-item>
          <el-breadcrumb-item :to="{path:'/dict'}">增强学习</el-breadcrumb-item>
          <el-breadcrumb-item>{{ activeName=='0' ? '表格学习' : activeName=='1' ? 'AI 学习' : activeName=='2' ? '字段学习' : '个性系统字段' }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <div class="projectName">项目名称：{{ projectName }}</div>

        <!-- <el-tabs v-model="activeName" @tab-click="changeTab">
          <el-tab-pane label="表格学习" name="0"></el-tab-pane>
          <el-tab-pane label="AI学习" name="1"></el-tab-pane>
          <el-tab-pane label="字段学习" name="2"></el-tab-pane>
          <el-tab-pane label="个性系统字段" name="3"></el-tab-pane>
        </el-tabs> -->

        <div class="ftabBtn flex">
          <el-button v-if="activeName=='1'" type="success" size="small" @click="addAItips">添加AI学习</el-button>
          <!-- <el-button type="primary" size="small">导出</el-button> -->
          <!-- <el-button type="danger" size="small" @click="delHandel">删除</el-button> -->
          <el-button type="success" v-if="activeName=='2'" size="small" @click="addNewField">添加表头学习</el-button>
          <el-button type="success" v-if="activeName=='3'" size="small" @click="addPSNField">添加个性化字段</el-button>
        </div>
        <!-- <div class="flex">
          <el-form label-width="120px">
            <el-form-item label="增强学习提示词:">
              <el-input type="textarea" v-model="prompt" :autosize="{ minRows: 4,maxRows:10}" style="width:600px"></el-input>
            </el-form-item>
          </el-form>
          <el-popover placement="bottom" title="" width="500" trigger="hover">
            <el-button type="text" size="small" @click="copy()">复制</el-button>
            <div v-html="tipTxt2" class="tipTxt"></div>
            <i class="el-icon-question cp elIcon" slot="reference"></i>
          </el-popover>
          <el-button type="success" size="small" style="height: 32px; margin-left: 15px;" @click="savePrompt">保存提示词</el-button>
        </div> -->
        <el-table :data="tableData" border class="doc_table" @selection-change="handleSelectionChange" :max-height="tableHeight - 100 > 340 ? tableHeight - 100 : 340" v-loading="loading" style="width:100%">
          <el-table-column key="mul" type="selection" width="55" align="center"></el-table-column>
          <!-- AI 学习 -->
          <template v-if="activeName=='1'">
            <el-table-column label="序号" width="80" :show-overflow-tooltip="true" align="center">
              <template slot-scope={$index}> {{ $index + 1 }} </template>
            </el-table-column>
            <el-table-column label="用途" prop="purposeName" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column label="适用表格序号" prop="sheetNum" min-width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column label="内容" prop="promptValue" min-width="400" :show-overflow-tooltip="true" align="center">
            </el-table-column>
          </template>
          <!-- 字段学习 -->
          <template v-if="activeName=='2'">
             <el-table-column label="序号" width="80" :show-overflow-tooltip="true" align="center">
              <template slot-scope={$index}> {{ $index + 1 }} </template>
            </el-table-column>
            <el-table-column label="用途" prop="purposeName" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="sysName" label="系统表头" min-width="120" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column prop="defaultValue" label="缺省值" min-width="120" :show-overflow-tooltip="true" align="center">
              <template slot-scope={row}> {{ row.defaultValue ? row.defaultValue : '无' }}</template>
            </el-table-column>
            <el-table-column prop="calcValueStr" label="等于" min-width="300" :show-overflow-tooltip="true" align="center">
            </el-table-column>
          </template>
          <!-- 个性系统字段 -->
          <template v-if="activeName=='3'">
            <el-table-column label="序号" width="80" :show-overflow-tooltip="true" align="center">
              <template slot-scope={$index}> {{ $index + 1 }} </template>
            </el-table-column>
            <el-table-column label="用途" prop="purposeName" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column label="个性字段明细" prop="personFielValue" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column label="格式类型" prop="formatType" min-width="100" :show-overflow-tooltip="true" align="center">
            </el-table-column>
            <el-table-column label="说明" prop="desc" min-width="200" :show-overflow-tooltip="true" align="center">
            </el-table-column>
          </template>
          <el-table-column label="操作" min-width="200" align="center">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" size="small" @click="editHandel(row)">编辑</el-button>
                <el-popconfirm title="请确认是否删除" @confirm="delRow(row)" style="margin: 0 10px;">
                  <el-button type="text" slot="reference" size="small">删除</el-button>
                </el-popconfirm>
                <el-button type="text" size="small" @click="moveHandle(row,1)" v-if="activeName==='1'">上移</el-button>
                <el-button type="text" size="small" @click="moveHandle(row,0)" v-if="activeName==='1'">下移</el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="block">
          <el-pagination @current-change="handleCurrentChange" :current-page.sync="listQuery.PageModel.Page" :page-size="listQuery.PageModel.Rows" @size-change="handleSizeChange" :page-sizes="[10, 20, 50, 100, 200]" layout="total,sizes,prev,pager,next,jumper" :total="totalCount"></el-pagination>
        </div>

        <div class="btnBox">
          <el-button @click="goBack">返 回</el-button>
        </div>
      </div>
    </div>

    <!-- 新增/编辑学习表头字段 -->
    <el-dialog :title="type=='add' ? '添加学习表头字段' : '编辑'" :visible.sync="learnEditVisible" width="900px" class="res_dialog enter_dialog">
      <el-form :rules="rules" ref="dictForm" :model="dictForm" class="" label-width="100px" size="small" v-if="learnEditVisible">
        <el-form-item label="用途:">
          <el-checkbox-group v-model="purposeName">
            <el-checkbox label="薪资单"></el-checkbox>
            <el-checkbox label="核算单"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="系统字段:">
          <el-select v-model="dictForm.sysName" size="small" placeholder="" filterable clearable style="width: 180px;">
            <el-option v-for="(r, i) in allList" :key="i" :value="r.sVal"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="缺省值:">
          <el-input v-model="dictForm.defaultValue" size="small" clearable style="width:180px"></el-input>
        </el-form-item>
        <el-form-item label="">
          <div v-for="(item, index) in dictForm.calcValueList" :key="index" class="ruleItem flex">

            <el-select v-model="item.calculationSymbol" size="small" placeholder="" style="width: 60px;margin-right: 10px;" v-if="index!=0">
              <el-option value="无"></el-option>
              <el-option value="+"></el-option>
              <el-option value="-"></el-option>
              <el-option label="×" value="*"></el-option>
              <el-option label="÷" value="/"></el-option>
            </el-select>

            <div style="margin-right: 10px;" v-if="index==0">=</div>

            <el-select v-model="item.bracket1" size="small" placeholder="括号操作" style="width: 100px;margin-right: 10px;" clearable>
              <el-option value="("></el-option>
              <el-option value=")"></el-option>
            </el-select>

            <el-select v-model="item.sheetNum" size="small" placeholder="表序号" style="width: 80px;margin-right: 10px;" clearable>
              <el-option v-for="item in 10" :key="item" :value="item"></el-option>
            </el-select>

            <el-select v-model="item.type" size="small" placeholder="" filterable clearable style="width: 140px;margin-right: 10px;" @change="val=>{changeType(val,item)}">
              <el-option label="系统字段" value="1"></el-option>
              <el-option label="指定表头位置" value="2"></el-option>
              <el-option label="指定内容表头" value="3"></el-option>
              <el-option label="固定值" value="4"></el-option>
              <el-option label="个性化字段" value="5"></el-option>
            </el-select>
            <el-select v-model="item.val1" size="small" placeholder="" filterable clearable style="width: 140px;" v-if="item.type == 1">
              <el-option v-for="(r, i) in allList" :key="i" :value="r.sVal"></el-option>
            </el-select>
            <div v-if="item.type == 2" class="flex aic">
              <el-input v-model="item.val1" type="number" size="small" clearable style="width:60px;margin-left: 10px;"></el-input>
              <div style="margin: 0 5px;">行</div>
              <el-input v-model="item.val2" type="number" size="small" clearable style="width:60px;margin-left: 10px;"></el-input>
              <div style="margin: 0 5px;">列</div>
            </div>
            <div v-if="item.type == 3" class="flex aic">
              <el-input v-model="item.val1" size="small" clearable style="width:120px;"></el-input>
              <!-- <div style="margin: 0 5px;">列</div> -->
            </div>
            <el-input v-if="item.type == 4" v-model="item.val1" size="small" clearable style="width:140px;"></el-input>

            <el-select v-model="item.val1" size="small" placeholder="" filterable clearable style="width: 140px;" v-if="item.type == 5">
              <el-option v-for="(r, i) in psnFieldList" :key="i" :value="r.personFielValue"></el-option>
            </el-select>

            <el-select v-model="item.bracket2" size="small" placeholder="括号操作" style="width: 100px;margin: 0 10px;" clearable>
              <el-option value="("></el-option>
              <el-option value=")"></el-option>
            </el-select>


            <i class="el-icon-delete icon02 cp" v-if="index != 0" @click="delRule(index)"></i>
            <div class="flex aic cp" style="margin-left:10px" @click="addRule" v-if="dictForm.calcValueList.length - 1 == index">
              <i class="el-icon-circle-plus icon01"></i>
              <el-button type="text" style="margin-left:5px">添加</el-button>
            </div>
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="learnEditVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmEdit" size="small" :loading="isBtnLoading">确定</el-button>
      </span>
    </el-dialog>


    <el-dialog :title="type=='add' ? '添加AI提示词' : '编辑'" :visible.sync="AITipEditVisible" width="500px" class="res_dialog enter_dialog">
      <el-form :rules="rules" ref="tipForm" :model="tipForm" class="" label-width="100px" size="small">
        <el-form-item label="用途:">
          <el-checkbox-group v-model="purposeName">
            <el-checkbox label="薪资单"></el-checkbox>
            <el-checkbox label="核算单"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="提示词内容:">
          <el-input v-model="tipForm.promptValue" type="textarea" :autosize="{ minRows: 3}" size="small" clearable style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="适用指定表格:">
          <el-select v-model="sheetNum" size="small" placeholder="" style="width: 300px;" multiple>
            <el-option v-for="item in 10" :key="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="AITipEditVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmSaveTip" size="small" :loading="isBtnLoading">确定</el-button>
      </span>
    </el-dialog>

    <el-dialog :title="type=='add' ? '添加表头字段' : '编辑'" :visible.sync="psnFieldEditVisible" width="500px" class="res_dialog enter_dialog">
      <el-form :rules="rules" ref="psnFieldForm" :model="psnFieldForm" class="" label-width="100px" size="small">
        <el-form-item label="用途:">
          <el-checkbox-group v-model="purposeName">
            <el-checkbox label="薪资单"></el-checkbox>
            <el-checkbox label="核算单"></el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="个性字段明细:">
          <el-input v-model="psnFieldForm.personFielValue" size="small" clearable style="width:300px"></el-input>
        </el-form-item>
        <el-form-item label="格式类型:">
          <el-select v-model="psnFieldForm.formatType" size="small" placeholder="" style="width: 300px;">
            <el-option value="字符数据类型"></el-option>
            <el-option value="数字数据类型"></el-option>
            <el-option value="货币数据类型"></el-option>
            <el-option value="特殊数据类型"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="说明:">
          <el-input v-model="psnFieldForm.desc" type="textarea" :autosize="{ minRows: 3}" size="small" clearable style="width:300px"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="psnFieldEditVisible = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmSavePsnField" size="small" :loading="isBtnLoading">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        tableHeight: Number(document.body.clientHeight),
        listQuery: {
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: []
          },
          id: '',
          purposeName: '',
        },
        id: '',
        isBtnLoading: false,
        KeyList: [],
        dictForm: {
          id: '',
          parentId: '',
          sysName: '',
          defaultValue: null,
          calcValueList: [{
            type: "",
            val1: "",
            val2: "",
            calculationSymbol: "=",
            bracket1: '',
            bracket2: '',
            sheetNum: ''
          }]
        },
        type: '',
        learnEditVisible: false,
        activeName: '4',
        activeName: '0',
        totalCount: 0,
        tableData: [],
        allList: [], //所有字段
        roletype: localStorage.loginRoletype,
        loading: false,
        multipleSelection: [],
        permissionLists: [],
        rules: {},
        ruleForm: {},
        projectName: '',
        prompt: '', //提示词
        promptid: '',
        tipTxt: '',
        tipTxt2: '',
        activeName: '1',
        AITipEditVisible: false,
        psnFieldEditVisible: false,
        purposeName: [],
        sheetNum: [],
        tipForm: {
          id: '',
          purposeName: '', //用途
          parentId: '',
          promptValue: '', //提示词内容
          sheetNum: '', //适用表格序号
          msg2: '',
        },
        psnFieldForm: {
          id: '',
          purposeName: '', //用途
          parentId: '',
          personFielValue: '', //个性字段明细
          formatType: '', //格式类型
          desc: '', //说明
        },
        psnFieldList: [], //个性化字段列表
      }
    },
    created() {
      if (this.$route.query.id != undefined && this.$route.query.id) {
        this.listQuery.id = this.$route.query.id;
        this.projectName = this.$route.query.projectName;
        this.activeName = this.$route.query.activeName;
        this.parentId = this.$route.query.id;
        this.changeTab();
      }
    },
    methods: {
      checkPermission,
      searchHandle() {
        this.listQuery.PageModel.Page = 1;
        this.getList();
      },
      //分页
      handleCurrentChange(val) {
        this.listQuery.PageModel.Page = Number(val)
        this.getList()
      },
      handleSizeChange(val) {
        this.listQuery.PageModel.Page = 1
        this.listQuery.PageModel.Rows = Number(val)
        this.getList()
      },
      getTips() {
        let str = `?ProjectName=${this.projectName}`
        xz.ArdCurStatGetFun('GetProjectLearningTips', str).then(res => {
          if (res.status == 'ok') {
            this.promptid = res.data.id;
            this.prompt = res.data.msg;
            let str = `?id=24`
            xz.ArdCurStatGetFun('GetOpenRetPrompt', str).then(r => {
              if (r.status == 'ok') {
                this.tipTxt = r.data;
                this.tipTxt2 = r.data.replace(/\r\n\t?/g, '</br>');
                if (!this.prompt || this.prompt == null) {
                  this.prompt = r.data;
                }
              } else {}
            })
          } else {
            // this.payCompList = [];
          }
        })
      },
      getList() {
        let pagename = '';
        if (this.activeName == '0') {
          pagename = '';
        } else if (this.activeName == '1') {
          pagename = 'GetHeaderPromptDetailList';
        } else if (this.activeName == '2') {
          pagename = 'GetHeaderLearningDetailList';
        } else if (this.activeName == '3') {
          pagename = 'GetHeaderPersonFielDetailList';
        }
        this.loading = true;
        xz.ArdCurStat(this.listQuery, pagename).then(res => {
          if (res.status == 'ok') {
            this.tableData = res.data.data;
            this.totalCount = res.data.pageModel.totalCount;
            this.loading = false;
          } else {
            this.tableData = [];
            this.totalCount = 0;
            this.loading = false;
          }
        })
      },
      GetAllList() {
        let str = `?input=null`
        xz.ArdCurStatGetFun('GetApplySalaryDetailSFieldsList', str).then(res => {
          if (res.status == 'ok') {
            this.allList = res.data;
          }
        })
      },
      changeTab() {
        if (this.activeName == '1') {
          this.listQuery = {
            PageModel: {
              Rows: 10,
              Page: 1,
              OrderInput: []
            },
            id: this.parentId,
            purposeName: '',
          }
        } else if (this.activeName == '2') {
          this.listQuery = {
            PageModel: {
              Rows: 100,
              Page: 1,
              OrderInput: []
            },
            id: this.parentId,
            sysName: '',
          }
          this.GetAllList();
          this.getPsnFieldList();
        }
        this.getList();
      },
      // 表格多选
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      //编辑
      editHandel(row) {
        this.type = 'edit';
        this.isBtnLoading = false;
        if (this.activeName == '1') {
          this.tipForm = {
            id: row.id,
            purposeName: row.purposeName, //用途
            parentId: row.parentId,
            promptValue: row.promptValue, //提示词内容
            sheetNum: row.sheetNum, //适用表格序号
            msg2: row.msg2,
          }
          this.purposeName = this.tipForm.purposeName.split(',');
          this.sheetNum = this.tipForm.sheetNum.split(',');
          this.AITipEditVisible = true;
        } else if (this.activeName == '2') {
          this.dictForm = {
            id: row.id,
            parentId: this.parentId,
            sysName: row.sysName,
            defaultValue: row.defaultValue,
            calcValueList: JSON.parse(row.calcValue)
          }
          if(row.purposeName!=undefined && row.purposeName){
            this.purposeName = row.purposeName.split(',');
          }else{
            this.purposeName = [];
          }
          this.learnEditVisible = true;
        } else if (this.activeName == '3') {
          this.psnFieldForm = {
            id: row.id,
            purposeName: row.purposeName, //用途
            parentId: row.parentId,
            personFielValue: row.personFielValue, //提示词内容
            formatType: row.formatType, //适用表格序号
            desc: row.desc,
          }
          this.purposeName = this.psnFieldForm.purposeName.split(',');
          this.psnFieldEditVisible = true;
        }
      },
      chengeType(val) {
        if (val == '计算公式') {
          this.ruleForm = {
            formula: {
              operator: '=',
              values: [{
                name: ''
              }],
            },
            rule: '计算公式',
            systemField: this.dictForm.msg
          }
        }
      },
      addNewField() {
        this.isBtnLoading = false;
        this.KeyList = [''];
        this.dictForm = {
          id: '',
          parentId: this.parentId,
          sysName: '',
          defaultValue: null,
          calcValueList: [{
            type: "",
            val1: "",
            val2: "",
            calculationSymbol: "="
          }]
        }
        this.type = 'add';
        this.purposeName = [];
        this.learnEditVisible = true;
      },
      //新增匹配字段
      addItem() {
        this.KeyList.push('')
      },
      delItem(i) {
        this.KeyList.splice(i, 1)
      },
      //添加计算公式
      addRule() {
        let d = {
          type: "",
          val1: "",
          val2: "",
          calculationSymbol: ""
        }
        this.dictForm.calcValueList.push(d);
      },
      delRule(i) {
        this.dictForm.calcValueList.splice(i, 1)
      },
      delRow(row) {
        let d = {};
        let pagename = '';
        if (this.activeName == '1') {
          d = {
            id: row.id,
            isDeleted: true
          }
          pagename = 'AddUpdataDelHeaderPromptDetail'
        } else if (this.activeName == '2') {
          d = {
            id: row.id,
            parentId: this.parentId,
            sysName: row.sysName,
            isDeleted: true,
            defaultValue: row.defaultValue,
            calcValueList: JSON.parse(row.calcValue)
          }
          pagename = 'AddUpdataDelHeaderLearningDetail'
        } else if (this.activeName == '3') {
          d = {
            id: row.id,
            isDeleted: true
          }
          pagename = 'AddUpdataDelHeaderPersonFielDetail'
        }
        xz.ArdCurStat(d, pagename).then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.$message.success('删除成功');
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      confirmEdit() {
        this.isBtnLoading = true;
        this.dictForm.purposeName = this.purposeName.toString();
        xz.ArdCurStat(this.dictForm, 'AddUpdataDelHeaderLearningDetail').then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.isBtnLoading = false;
            this.$message.success('保存成功');
            this.learnEditVisible = false;
          } else {
            this.isBtnLoading = false;
            this.$message.error(res.msg);
          }
        })
      },
      delHandel() {
        if (this.multipleSelection.length > 0) {
          this.loading = true;
          let arr = [];
          this.multipleSelection.forEach((e, i) => {
            arr.push(e.id)
            if (i == this.multipleSelection.length - 1) {
              let d = {
                id: arr
              }
              xz.RPAdel(d, 'DeleteToget').then(res => {
                if (res.status == 'ok') {
                  this.getList();
                  this.loading = false;
                  this.$message.success('删除成功');
                } else {
                  this.loading = false;
                  this.$message.error(res.msg);
                }
              })
            }
          });
        } else {
          this.$message.warning('请至少选择一个任务')
        }
      },
      getVal(val) {
        let v = JSON.parse(val);
        // v.formula.values[0].name + 
        let str = ''
        v.formula.values.forEach((e, i) => {
          if (e.operation != undefined && e.operation) {
            str = str + e.operation
          }
          if (e.name != '固定值') {
            str = str + e.name
          } else {
            str = str + e.value
          }
        });
        return str
      },
      //返回
      goBack() {
        window.close()
      },
      savePrompt() {
        if (!this.prompt) {
          this.$message.warning('请填写提示语')
        } else {
          this.isBtnLoading = true;
          let d = {
            id: this.promptid,
            msg: this.prompt
          }
          xz.ArdCurStat(d, 'UpdataProjectLearningTips').then(res => {
            if (res.status == 'ok') {
              this.isBtnLoading = false;
              this.$message.success('保存成功');
            } else {
              this.isBtnLoading = false;
              this.$message.error(res.msg);
            }
          })
        }
      },
      copy() {
        navigator.clipboard.writeText(this.tipTxt).then(() => {
          this.$message.success('复制成功')
        })
      },
      GetOpenRetPrompt() {
        let str = `?id=24`
        xz.ArdCurStatGetFun('GetOpenRetPrompt', str).then(res => {
          if (res.status == 'ok') {
            this.tipTxt = res.data;
            this.tipTxt2 = res.data.replace(/\r\n\t?/g, '</br>');
          } else {}
        })
      },
      //新增AI学习提示词
      addAItips() {
        this.isBtnLoading = false;
        this.tipForm = {
          id: '',
          purposeName: '', //用途
          parentId: this.parentId,
          promptValue: '', //提示词内容
          sheetNum: '', //适用表格序号
          msg2: '',
        }
        this.purposeName = [];
        this.sheetNum = [];
        this.AITipEditVisible = true;
      },
      confirmSaveTip() {
        if (this.purposeName.length > 0) {
          this.tipForm.purposeName = this.purposeName.toString();
          this.tipForm.sheetNum = this.sheetNum.toString();
          this.isBtnLoading = true;
          xz.ArdCurStat(this.tipForm, 'AddUpdataDelHeaderPromptDetail').then(res => {
            if (res.status == 'ok') {
              this.getList();
              this.isBtnLoading = false;
              this.$message.success('保存成功');
              this.AITipEditVisible = false;
            } else {
              this.isBtnLoading = false;
              this.$message.error(res.msg);
            }
          })
        } else {
          this.$message.warning('请选择用途')
        }
      },
      moveHandle(row, sort) {
        this.loading = true;
        let str = `?id=${row.id}&Sort=${sort}`;
        xz.ArdCurStatGetFun('HeaderPromptDetailSort', str).then(res => {
          if (res.status == 'ok') {
            this.getList();
            this.loading = false;
            this.$message.success('操作成功');
          } else {
            this.loading = false;
            this.$message.error(res.msg);
          }
        })
      },
      addPSNField() {
        this.isBtnLoading = false;
        this.psnFieldForm = {
          id: '',
          purposeName: '', //用途
          parentId: this.parentId,
          personFielValue: '', //个性字段明细
          formatType: '', //格式类型
          desc: '', //说明
        }
        this.purposeName = [];
        this.psnFieldEditVisible = true;
      },
      confirmSavePsnField() {
        if (this.purposeName.length > 0) {
          this.psnFieldForm.purposeName = this.purposeName.toString();
          this.isBtnLoading = true;
          xz.ArdCurStat(this.psnFieldForm, 'AddUpdataDelHeaderPersonFielDetail').then(res => {
            if (res.status == 'ok') {
              this.getList();
              this.isBtnLoading = false;
              this.$message.success('保存成功');
              this.psnFieldEditVisible = false;
            } else {
              this.isBtnLoading = false;
              this.$message.error(res.msg);
            }
          })
        } else {
          this.$message.warning('请选择用途')
        }
      },
      getPsnFieldList() {
        let d = {
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: [{
              property: "msg1",
              order: 1
            }]
          },
          id: "",
          projectName: this.projectName,
          msg: ""
        }
        xz.ArdCurStat(d, 'GetHeaderPersonFieldList').then(res => {
          if (res.status == 'ok') {
            if (res.data.data.length > 0) {
              let dd = {
                PageModel: {
                  Rows: 10,
                  Page: 1,
                  OrderInput: []
                },
                id: res.data.data[0].id,
                purposeName: '',
              }
              xz.ArdCurStat(dd, 'GetHeaderPersonFielDetailList').then(r => {
                if (r.status == 'ok') {
                  this.psnFieldList = r.data.data
                } else {
                  this.psnFieldList = []
                }
              })
            }
          } else {
            this.psnFieldList = []
          }
        })
      },
      changeType(val,item){
        this.$set(item,'val1','')
        this.$set(item,'val2','')
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .ruleItem {
    margin-top: 10px;
  }

  .icon01 {
    color: #19bd92;
    font-size: 20px;
    cursor: pointer;
  }

  .icon02 {
    // color: #19bd92;
    font-size: 20px;
    cursor: pointer;
    margin-left: 5px;
    line-height: 32px;
  }

  .btnBox {
    margin-top: 20px;
    width: 95%;
    display: flex;
    justify-content: center;
  }

  .projectName {
    margin-bottom: 10px;
    padding-top: 15px;
    font-size: 16px;
    font-weight: 600;
  }

  .elIcon {
    font-size: 24px;
    color: red;
    margin-left: 15px;
  }

  .tipTxt {
    max-height: 300px;
    overflow-y: scroll;
  }
</style>
<style>
  .page_settlementTask .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_settlementTask .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_settlementTask .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_settlementTask .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_settlementTask .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_settlementTask .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }
</style>